import type { FC, ReactNode } from "react";

import { EMPTY_STRING } from "@roko/ui/constants/common";

interface ITypographyProps {
  children: ReactNode;
  className?: string;
}

export const H1: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h1 className={`text-2xl font-semibold leading-normal ${className}`}>
    {children}
  </h1>
);

export const H2: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h2 className={`text-xl font-bold leading-tight tracking-tight ${className}`}>
    {children}
  </h2>
);

export const H3: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h3 className={`text-lg font-semibold leading-snug ${className}`}>
    {children}
  </h3>
);

export const H4: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h4 className={`text-base font-semibold leading-snug ${className}`}>
    {children}
  </h4>
);

export const H5: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h5 className={`text-sm font-semibold leading-normal ${className}`}>
    {children}
  </h5>
);

export const H6: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <h6 className={`text-xs font-semibold leading-normal ${className}`}>
    {children}
  </h6>
);

export const LargeLabel: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <p className={`text-sm font-semibold leading-[20px]  ${className}`}>
    {children}
  </p>
);

export const Paragraph: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => <p className={`text-base leading-relaxed ${className}`}>{children}</p>;

export const LargeParagraph: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => <p className={`text-lg leading-relaxed ${className}`}>{children}</p>;

export const SmallParagraph: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => <p className={`text-sm leading-normal ${className}`}>{children}</p>;

export const Caption: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <p className={`text-xs leading-normal tracking-wide ${className}`}>
    {children}
  </p>
);

export const Code: FC<ITypographyProps> = ({
  children,
  className = EMPTY_STRING,
}) => (
  <code
    className={`font-mono text-sm leading-normal bg-muted px-1 py-0.5 rounded-sm ${className}`}
  >
    {children}
  </code>
);
